import { useAppSelector } from "../redux/store";

const GetInvoiceLabels = () => {
  const customerJourney = useAppSelector((state) => state.customerJourney);
  const { pageText }: any = customerJourney;
  const invoiceTypes = [
    {
      label: pageText?.labelsMetadata?.invoiceOrderTypeMyselfLabel,
      value: "myself",
      disabled: false,
      checked: false,
    },
    {
      label: pageText?.labelsMetadata?.invoiceOrderTypeAnotherPersonLabel,
      value: "another",
      disabled: false,
      checked: false,
    },
    {
      label: pageText?.labelsMetadata?.invoiceOrderTypeCompanyLabel,
      value: "company",
      disabled: false,
      checked: false,
    },
  ];

  return pageText ? invoiceTypes : [];
};

export default GetInvoiceLabels;